import Vue from 'vue';
import store from '@/store';
import $ from 'jquery'

import AddProvisionModal from './AddProvisionModal.vue';

export default function(){
    let element = $(`<div id="gnzs-1c-amo__add-provision-modal-container"></div>`)
    $('body').append(element)

    new Vue({
        store,
        render: h => h(AddProvisionModal)
    }).$mount('#gnzs-1c-amo__add-provision-modal-container');
}